import stbAPIGateway from '../../../../services/stbAPIGateway';

export const fetchClientVendorStudentGroups = async (
  { rootGetters },
  { clientSid, queryParam }
) => {
  const axios = rootGetters['app/stbAxios'];
  const apiUrl = process.env.API_URL || '';
  const stbApi = stbAPIGateway(axios, apiUrl);
  const response = await stbApi.getClientVendorStudentGroups(clientSid, queryParam);
  return response;
};
